<template>
  <div class="topbar">
    <div class="topbar-left">
      <img class="logo" src="../assets/img/微信图片_20250324134230.jpg" alt="logo" />
      <span class="school-name">中国心理卫生协会</span>
    </div>
    <div class="topbar-right">
      <!-- <a class="back-to-home" href="https://www.camh.org.cn/" target="_blank" rel="noopener noreferrer">返回官网</a> -->
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item command="userInfo">个人信息</el-dropdown-item> -->
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <img class="avatar" src="https://i.loli.net/2021/03/19/6Qw2J4j1K8n3v5A.png" alt="avatar"> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import authService from '../common/auth.js'

export default {
  name: 'Topbar',
  data() {
    return {
      userInfo: null
    }
  },
  computed: {
    ...mapState(['token']),
    userName() {
      if (this.userInfo && this.userInfo.name) {
        return this.userInfo.name;
      } else if (this.userInfo && this.userInfo.nickname) {
        return this.userInfo.nickname;
      } else if (this.userInfo && this.userInfo.username) {
        return this.userInfo.username;
      } else if (this.token) {
        // 使用token的前8位作为用户名显示
        return this.token.substring(0, 8) + '...';
      }
      return '未登录';
    }
  },
  async mounted() {
    // 如果已经有token，主动获取用户信息（处理页面刷新后token已存在的情况）
    if (this.token) {
      await this.getUserInfo();
    }
  },
  watch: {
    // 监听token变化，重新获取用户信息
    token: {
      handler(newToken, oldToken) {
        // token变化时调用（包括从null变为有值，或从有值变为null）
        if (newToken && newToken !== oldToken) {
          this.getUserInfo();
        } else if (!newToken) {
          this.userInfo = null;
        }
      }
    }
  },
  methods: {
    async getUserInfo() {
      try {
        const result = await authService.getUserInfo();
        if (result.success) {
          this.userInfo = result.data;
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
    
    async handleCommand(command) {
      if (command === 'logout') {
        await this.logout();
      } else if (command === 'userInfo') {
        this.showUserInfo();
      }
    },
    
    showUserInfo() {
      // 可以在这里添加显示用户信息的逻辑
      // 比如打开一个对话框或者跳转到用户信息页面
      this.$message.info('用户信息功能开发中...');
    },
    
    async logout() {
      try {
        await authService.logout();
        // 页面会在 authService.logout() 中跳转，这里不需要额外处理
      } catch (error) {
        console.error('退出登录失败:', error);
        // 即使出错，页面也会跳转，所以不需要显示错误消息
      }
    }
  }
}
</script>

<style scoped>
.topbar {
  height: 64px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 36px 0 0;
  color: #000000;
}
.topbar-left {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 36px;
}
.logo {
  height: 38px;
  margin-right: 18px;
}
.school-name {
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 2px;
}
.topbar-right {
  display: flex;
  align-items: center;
  gap: 18px;
}
.invite-input {
  width: 120px;
  margin-right: 10px;
}
.topbar .avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-left: 10px;
  border: 2px solid #000000;
}
.el-dropdown-link {
  cursor: pointer;
  color: #000000;
  font-size: 16px;
  margin-left: 10px;
}
.back-to-home {
  color: #888;
  font-size: 13px;
  margin-right: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  text-decoration: none;
  transition: background 0.2s;
}
.back-to-home:hover {
  background: #e0e0e0;
}
</style> 